export enum TenantActionType {
    DELETE = 'delete',
    DUPLICATE = 'duplicate',
}
